import React, { useMemo } from "react";
import Wizard from "../../components/react-componnets/components/wizardPage/index";

const AddUser = ({ acuModels, closeACUModal, showNotification }) => {
  const getControllersData = (controllers) => {
    const data = [];

    for (const key in controllers) {
      data.push({
        id: `${Date.now()}_${key}`,
        name: key,
        ...controllers[key],
        img: controllers[key].img
          ? `${process.env.VUE_APP_BACK}/${controllers[key].img}`
          : "https://invidtech.com/cdn/shop/files/INVID-AIR-CR_3000_700x700.jpg?v=1695215162",
      });
    }
    return data;
  };
  const data = useMemo(() => {
    return getControllersData(acuModels);
  }, []);
  return (
    <div>
      <Wizard
        data={data}
        closeACUModal={closeACUModal}
        showNotificationPopUp={showNotification}
      />
    </div>
  );
};

export default AddUser;
